const infotext = (
    <>  
        <h1>
            <span className="viking-font">FörSta Dagen - 18 AuguSti</span>
        </h1>
        <p>
            Klockan 07.50 har <span className="viking-font">N0llan</span> möjlighet att möta upp faddrar och andra <span className="viking-font">N0llan</span> på{" "}
            <a
                href="https://maps.app.goo.gl/6FULfciysMCQd22y9"
                target="_blank"
                rel="noopener noreferrer"
            >
                MatNat-kullen
            </a>
            . Detta är ett suuuperbra tillfälle för <span className="viking-font">N0llan</span> att träffa andra <span className="viking-font">N0llan</span> på MatNat-sektionen, 
            men också ett mycket bra sätt att få hjälp med att hitta rätt till det obligatoriska uppropet, för det vill <span className="viking-font">N0llan</span> inte komma sent till. 
            <br/>
            Klockan 08:30 ska <span className="viking-font">N0llan</span> infinna sig i{" "}
             <a
                href="https://link.mazemap.com/lYiUbgNu"
                target="_blank"
                rel="noopener noreferrer"
            >
                C4
            </a>
            , för upprop. Där kommer <span className="viking-font">N0llan</span> tacka ja till sin plats på Linköpings Universitet, och få viktig information om sina studier.
            
            Efter uppropet inleds en dag full med spännande aktiviteter.
            <span className="viking-font"> N0llan</span> kommer att bjudas på lunch, men det kan vara bra att ta med en vattenflaska ifall <span className="viking-font">N0llan</span> blir törstig. 
        </p>

        <h1>
            <span className="viking-font">N0llepaketet </span>
        </h1>
        <p>
            Inför <span className="viking-font">N0lle-P</span> kommer <span className="viking-font">N0llan</span> ha möjlighet att köpa det så kallade N0llepaketet, för att <span className="viking-font">N0llan</span> ska få möjlighet att vara med på alla event.
            <b> Det som ingår i N0llepaketet är: </b> <br/>
            <br/>

            <u> <span className="viking-font">* N0llan</span> <b> får biljett till och mat + dryck på: </b> </u> <br/>
            Skördesitsen, en rolig sittning där det kommer bjudas på mat, dryck och underhållning. <br/>
            TBGFLing, en sittning där <span className="viking-font">N0llan</span> får möjlighet att äta middag med andra <span className="viking-font">N0llan</span> från Ling-och TBI-sektionen. <br/>
            <br/>

            <u> <span className="viking-font">* N0llan</span> <b> får mat + dryck på: </b> </u> <br/>
            Hajken, ett superkul tillfälle för <span className="viking-font">N0llan</span> att lära känna varandra bättre på en campingtur i Linköpings skogar. <br/>
            OMG-grillen, vilket är MatNats grillkväll för <span className="viking-font">N0llan</span>. <br/>
            Gubbens dag, en myyycket spännande eftermiddag med tidernas underhållning som <span className="viking-font">N0llan</span> inte vill missa. <br/>
            <br/>

            <u> <span className="viking-font">* N0llan</span> <b> får mat på: </b> </u> <br/>
            Stadsvandring, en guidad tur runt Linköping med mycket skoj planerat.<br/>
            <br/>

            <u> <span className="viking-font">* N0llan</span> <b> får biljett till: </b> </u> <br/>
            DiskoTeKKFak och CMYFLinGF, vilka båda är N0llediscon där <span className="viking-font">N0llan</span> får möjlighet att träffa <span className="viking-font">N0llan</span> på andra sektioner och skaka loss på dansgolvet. <br/>
            <br/>

            <span className="viking-font">N0llan</span> som inte köpt N0llepaketet kommer ej serveras någon mat eller dryck på dessa event, och inte heller få biljett till de event där det krävs. <br/>
            <br/>

            N0llepaketet kostar 315kr, och <span className="viking-font">N0llan</span> betalar genom att föra över pengarna till <span className="viking-font">gUDfADDerieT</span>s plusgiro: 408 23 36-1. 
            I betalningen behöver <span className="viking-font">N0llan</span> skriva NP för N0llepaketet och sitt för- och efternamn, för att <span className="viking-font">gUDfADDerieT</span> ska kunna se vem som köpt N0llepaketet. <br/>
            <br/>
            För att tydliggöra ska <span className="viking-font">N0llan</span> som vill köpa N0llepaketet föra över 315 kr till: <br/>
            Plusgiro: 408 23 36-1 <br/>
            Meddelande: NP_FörnamnEfternamn <br/>

            Kom ihåg <span className="viking-font">N0llan</span>! <span className="viking-font">N0llan</span> behöver köpa N0llepaketet senast den 18 augusti.
        </p>

        <h1>
            <span className="viking-font">ORBI</span>
        </h1>
        <p>
            Oavsett om <span className="viking-font">N0llan</span> väljer att köpa N0llepaketet eller inte, är det sedan dags att ladda ned en app som heter Orbi. Den används för biljetter till olika event, och är mycket viktig att ha för att kunna vara med på allt skoj under <span className="viking-font">N0lle-P</span>. 
            Orbi används även efter <span className="viking-font">N0lle-P</span> för biljetter till olika evenemang. För att veta exakt hur <span className="viking-font">N0llan</span> ska gå tillväga efter att ha laddat ned Orbi kan <span className="viking-font">N0llan</span> läsa här. 

            När <span className="viking-font">N0llan</span> laddat ned Orbi och skapat konto väljer <span className="viking-font">N0llan</span> antingen medlemskapet "N0llepaket" eller "Inget N0llepaket" . 
            Detta är viktigt för att <span className="viking-font">N0llan</span> ska kunna få biljetter till event under <span className="viking-font">N0lle-P</span>. Om <span className="viking-font">N0llan</span> har problem med eller frågor om Orbi går det bra att kontakta contact@orbiapp.io.

            För att få biljetter till vissa av eventen, som TBGFLing och N0llediscon, behöver <span className="viking-font">N0llan</span> utöver att välja medlemskapet även skaffa biljett till de separata eventen. 
            Även detta görs i Orbi, och kan behöva göras några dagar i förväg. <span className="viking-font">N0llan</span> kommer få information från faddrarna om när sista dagen att skaffa biljett till de olika eventen är! 
        </p>

        <h1> 
            <span className="viking-font">LiU:S cHeckliSta </span>
        </h1>
        <p>
            Något som är mycket bra om <span className="viking-font"><span className="viking-font">N0lle-P</span></span> gör är att kolla på{" "}
            <a
                href="https://liu.se/artikel/checklistor"
                target="_blank"
                rel="noopener noreferrer"
            >
                LiU:s checklista för nya studenter  
            </a>
            . Där står allt viktigt <span className="viking-font">N0llan</span> behöver göra innan <span className="viking-font">N0llan</span> börjar på Linköpings Universitet. 
            Det är extra viktigt att <span className="viking-font">N0llan</span> aktiverar sitt LiU-ID, för att <span className="viking-font">N0llan</span> ska få tillgång till sin skolmail. 
        </p>

        <br/>
        <p>
            Kom ihåg att <span className="viking-font">gUDfADDerieT</span> vill skydda <span className="viking-font">N0llan</span> och gör allt för <span className="viking-font">N0llan</span>s bästa. 
            Om <span className="viking-font">N0llan</span> har frågor eller något annat att förmedla är <span className="viking-font">N0llan</span> välkommen att maila till gf@gudfadderiet.se. För att underlätta, ange gärna relevant information i ämnesfältet.
        </p>

    </>
);
export default infotext;